import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'period',
  standalone: false,
})
export class PeriodPipe implements PipeTransform {
  transform(value: string): string {
    switch (value) {
      case 'month_1':
        return 'Monthly';
      case 'year_1':
        return '1 Year';
      case 'year_2':
        return '2 Years';
      case 'year_3':
        return '3 Years';
      default:
        return value;
    }
  }
}
